import { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";
import { api } from "@/lib/api";

export function GiftsDelivered() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/gifts/sent").then((r) => setList(r.data)).catch(() => {}); }, []);
  const dismiss = (token) => { setList((l) => l.filter((g) => g.token !== token)); api.post(`/gifts/${token}/dismiss`).catch(() => {}); };
  if (!list.length) return null;
  return (
    <div className="space-y-2 mb-6" data-testid="gifts-delivered">
      {list.map((g) => (
        <div key={g.token} className="flex items-center gap-3 rounded-xl border border-emerald-300 bg-emerald-50 p-3 text-sm text-emerald-900" data-testid={`gift-delivered-${g.token}`}>
          <Gift className="w-4 h-4 shrink-0" />
          <span className="flex-1"><strong>Regalo entregado a {g.recipient_name}</strong> · {g.workshop_name}</span>
          <button type="button" onClick={() => dismiss(g.token)} aria-label="Cerrar aviso" className="p-1 rounded hover:bg-emerald-100" data-testid={`gift-delivered-dismiss-${g.token}`}><X className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
  );
}
